// extracted by mini-css-extract-plugin
export default {"alert":"FormAlert_alert__lxTn5","danger":"FormAlert_danger__joFeg","success":"FormAlert_success__lGs6P","icon":"FormAlert_icon__+35-x","text":"FormAlert_text__8tYwh"};